import React, { useEffect, useMemo, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import OtherService from "../services/Other";
import ModalComponent from "../component/ModalComponent";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import NoData from "../component/NoData";
import RegistrationService from "../services/registration";
import PurchaseService from "../services/Purchase";
import InputField from "../component/InputField";
import ImagePreviewModal from "../component/Modals/ImagePreviewModal";

const SelfieApproval = () => {
    
  // const allStatus = [
  //   { id: "pending", title: "Pending", pageNo: 1 },
  //   { id: "accepted", title: "Approved / Rejected", pageNo: 1 },
  // ];
  const [loading, setLoading] = useState(true);
  const [myServiceData, setMyServiceData] = useState([]);
  const [currentServiceData, setCurrentServiceData] = useState([]);
  const [serviceRejectReasonData, setServiceRejectReasonData] = useState([]);
  const [serviceAcceptReasonData, setServiceAcceptReasonData] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: "",
    title: "",
  });
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
  const isHierDesc = userInfo?.description || null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRejectReasonShow, setIsRejectReasonShow] = useState(false);
  const [isAcceptReasonShow, setIsAcceptReasonShow] = useState(false);
  // const [serviceRejectReason, setServiceRejectReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [showAlert, setShowAlert] = useState(false); // show success or error message on modal
  const [isLoginSuccessCondition, setIsLoginSuccessCondition] = useState("");
  const [isLoginSuccessText, setIsLoginSuccessText] = useState("");
  const [isLoginSuccessHeading, setIsLoginSuccessHeading] = useState("");
  const [showMore, setShowMore] = useState(true);
  // const [status, setStatus] = useState(allStatus[0]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [allMarked, setAllMarked] = useState([]);
  const [allMItems, setAllMItems] = useState([]);
  const [selfieData, setSelfieData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({id: "", title: ""});
  const [search, setSearch] = useState({
    nameOrNumber: "",
    status: '',
    fullStatus: { title: '', id: '', searchBy: '' },
  });

  const dropdownData = useMemo(() => ([
    { title: 'All', id: 'all', searchBy: '' },
    { title: 'Accepted', id: 'accepted', searchBy: 'accepted' },
    { title: 'Rejected', id: 'rejected', searchBy: 'rejected' },
    { title: 'Pending', id: 'pending', searchBy: 'pending' },
  ]), []);
  

  const handleShowModal = async (item) => {
    // setSelectedEvent(event);

    setSelectedItem(item);

    const dcm_hierarchies_id = item.hier_id; //userData.dcm_hierarchies_id;
    const selfieApprovalRejectReasonsResponse =
      await PurchaseService.selfieApprovalReasons("reject");
    const selfieApprovalAcceptReasonsResponse =
      await PurchaseService.selfieApprovalReasons("accept");

    const filteredData =
      selfieApprovalRejectReasonsResponse.response?.reasons.map(reason => ({...reason, title: reason.name }));
    const filteredAcceptData =
      selfieApprovalAcceptReasonsResponse.response?.reasons.map(reason => ({...reason, title: reason.name }));

    setServiceRejectReasonData(filteredData);
    setServiceAcceptReasonData(filteredAcceptData);
    // If ther is any message in modal then hide first
    setShowAlert(false);
    // Open the modal
    setIsModalOpen(true);
  };

  // const handleRejectReasonOnChange = (selectedValue) => {
  //   // setSelectedItem(selectedValue);
  // };

  const handleApprove = async (accept_reject) => {
    let payload = {
      accept_or_reject: accept_reject,
      reasons: selectedValue.title,
      contact_id_contractor: selectedItem.contractor_contact_id,
      selfie_id: selectedItem.selfie_id,
      customer_name: selectedItem.name,
      mobile_number: selectedItem.no ?? ""
    };
    setLoading(true);
    PurchaseService.selfieAcceptReject(payload)
      .then(res => {
        setLoading(false)
        if(res.success) {
          toast.success(res.response.message)
          fetchData()
          setIsModalOpen(false);
        } else {
          toast.error(res.response.message)
        }
      })
      .catch(err => {
        // toast.show('', {
        //   data: {
        //     isSuccess: false,
        //     heading: 'Something went wrong',
        //     describe: res.message,
        //   }
        // });
      });
  };

  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  const fetchData = async (search={
    nameOrNumber: "",
    status: '',
    fullStatus: { title: '', id: '', searchBy: '' },
  }) => {
    try {
      setLoading(true)
        const res = await RegistrationService.selfieList(search);
        setLoading(false)
        if(res.success) {
            const allInfo = res.response?.data.map(item => ({
            id: item.selfie_id,
            name: item.full_name,
            description: 'Lorem ipsum dolor sit amet.',
            qty: `${parseInt(item.tonnage_sold)} Bags`,
            statusName: item.status == '0' ? 'Pending' : item.status == '1' ? 'Accepted' : 'Rejected',
            no: item.number,
            image: item.image_url,
            ...item
            }))
            setSelfieData(allInfo);
        }      
    } catch (e) {
      setLoading(false)
    } finally {
    }
  };
  useEffect(() => {
    fetchData(search);
  }, [search]);

  // function onLoadMore() {
  //   setStatus((p) => ({ ...p, pageNo: p.pageNo + 1 }));
  // }
  let headers = [];
  if (selfieData.length > 0) {
    headers = Object.keys(selfieData[0]);
  }

  // function onChecked(item) {

  //   // 
  //   // );
  //   if (allMarked.includes(item["Service Id"])) {
  //     const newList = allMItems.filter(
  //       (i) => i.service_id != item["Service Id"]
  //     );
  //     setAllMItems(newList);
  //     const list = allMarked.filter((i) => i != item["Service Id"]);
  //     setAllMarked(list);
  //   } else {
  //     if (allMarked.length > 14) {
  //       toast.error("Cannot approve more than 5 items");
  //       return;
  //     }

  //     setAllMarked((p) => [...p, item["Service Id"]]);
  //     setAllMItems((p) => [...p, { ...item.Select.item }]);
  //   }
  //   const updatedPList = myServiceData.map((service) => {

  //     if (service["Service Id"] === item["Service Id"]) {

  //         "upl",
  //         allMarked,
  //         service["Service Id"],
  //         item["Service Id"]
  //       );
  //       const { Select, ...rest } = service;
  //       return {
  //         Select: {
  //           isChecked: !allMarked.includes(item["Service Id"]),
  //           serviceStatus: item.Select.item.service_status,
  //           item: item.Select.item,
  //         },
  //         ...rest,
  //       };
  //     }
  //     return service;
  //   });

  //   setMyServiceData(updatedPList);
  // }

  // function submitHandler(item, idx, len, toastId) {
    
  // }

  // function approveAll() {

  //   const toastId = toast.loading("Loading...");
  //   allMItems.forEach((item, index) => {

  //     submitHandler(item, index + 1, allMItems.length, toastId);
  //   });
  // }

  function onHide() {
    setTimeout(() => {
      setIsAcceptReasonShow(false)
      setIsRejectReasonShow(false)
    }, 400)
  }

  async function reuploadHandler() {
    const payload = {
        // reasons: "dfbhcvfbv",
        contact_id_contractor: selectedItem.dcm_contacts_id,
        selfie_id: selectedItem.id,
        customer_name: selectedItem.name,
        mobile_number: selectedItem.no
    }
    try {
    const res = await PurchaseService.selfieReupload(payload);
        
        setIsModalOpen(false);
        if(res.success) {
          toast.success(res.response.message)
          fetchData(search)
        } else {
          toast.error(res.response.message)
        }
    } catch(err) {
      toast.error("Something went wrong")
    }
}

const handleImagePreview = (imageUrl) => {
  setSelectedImage(imageUrl);
  setShowImageModal(true);
};

  return (
    <>
        <BreadCrumbSecttion
            pageTitle="Selfie Approval"
            currentPageName="Selfie Approval"
        />
      <section className="padTop50">
        <Container>
          <Row>
            <Col xs={12} lg={12}>
              <div className="searchBoxBlock my-4">
                <Row>
                  <Col xs={12} lg={3}>
                    <SelectDropDown
                      labelName="Filter by status"
                      // requiredStar="*"
                      options={dropdownData}
                      setSelectedValue={(val) => setSearch(p => ({...p, status: val.searchBy, fullStatus: val}))}
                      selectedValue={search.fullStatus}
                      // onChange={handleContentDistrictNameChange}
                      page="searchFilter"
                    />
                  </Col>
                  <Col xs={12} lg={2}>
                    <InputField
                      inputFieldLabel="Search By Contractor Name or Mobile"
                      onChange={(e) => setSearch(p => ({...p, nameOrNumber: e.target.value}))}
                      value={search.nameOrNumber}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {selfieData.length == 0 && !loading && <NoData /> }
              {selfieData.length === 0 && loading && <NoData title="Loading..." />}
              {selfieData.length > 0 && <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {headers.length > 0 &&
                      ['Image', 'Name', 'Quantity', 'Contractor No.', 'Status'].map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {selfieData.length > 0 &&
                    selfieData.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                          <div 
                            className="adminLogoUserImg imageHoverWrapper"
                            style={{ display: "flex", alignItems: "center", gap: "10px", flexDirection: "row", justifyContent: 'space-between', width: "100%",  }}
                          >
                            <img
                              src={item["image"]}
                              alt="img"
                              className="image-selfie"
                              onClick={() => handleImagePreview(item["image"])}
                            />
                          </div>
                          </td>
                          <td>
                            <div>{item["name"]}</div>
                          </td>
                          <td>
                            <div>{item["qty"]}</div>
                          </td>
                          <td>
                            <div>{item["no"]}</div>
                          </td>
                          <td>
                          <div className="pendingStatusBlock">
                            <span className={item["status"] == 0 ? "pendingTxt" : item["status"] == 1 ? "approvedTxt" : "rejectedTxt"}>{item["status"] == 0 ? "Pending" : (item["status"] == 1 ? "Accepted" : "Rejected")}</span>
                            <button
                              className="checkNowBtn"
                              disabled={item["status"] != 0}
                              onClick={() => handleShowModal(item)}
                              style={{opacity: item["status"] != 0 ? 0.8 : 1}}
                            >
                              Check
                            </button>
                          </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>}
            </Col>
          </Row>

          <Col xs={12}>
            <ModalComponent
              onHide={onHide}
              page="selfieApproval"
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              serviceRejectReasonData={serviceRejectReasonData}
              serviceAcceptReasonData={serviceAcceptReasonData}
              serviceApproval={currentServiceData}
              outlinebuttonText="I Understood"
              onClick={""}
              modalTitle="Selfie Approval"
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              isRejectReasonShow={isRejectReasonShow}
              setIsRejectReasonShow={setIsRejectReasonShow}
              isAcceptReasonShow={isAcceptReasonShow}
              setIsAcceptReasonShow={setIsAcceptReasonShow}
              handleApprove={handleApprove}
              // handleRejectReasonOnChange={handleRejectReasonOnChange}
              showAlert={showAlert}
              isLoginSuccessText={isLoginSuccessText}
              isLoginSuccessCondition={isLoginSuccessCondition}
              isLoginSuccessHeading={isLoginSuccessHeading}
              setOtherReason={setOtherReason}
              otherReason={otherReason}
              reuploadHandler={reuploadHandler}
            />
            <ImagePreviewModal showImageModal={showImageModal} setShowImageModal={setShowImageModal} selectedImage={selectedImage} />
          </Col>
        </Container>
      </section>
    </>
  );
};

export default SelfieApproval;
